import { html } from 'lit-html';
import { ItemJsEnv } from '../../models/item_js_env';
import { RecommendRelatedItems } from './recommend_related_item';
import { InflowWordItems } from './inflow_word_item';

// prettierの自動整形をしたくない場合だけ付与する
// prettier-ignore
export const ItemBody = (model: ItemJsEnv) => html`
${RecommendRelatedItems(model)}
`;

export const ItemBodySecond = (model: ItemJsEnv) => html`
${InflowWordItems(model)}
`;
